import classNames from 'classnames';
import type { CSSProperties, ReactElement } from 'react';
import FJResourceItemLoading from '../FJResourceItemLoading/FJResourceItemLoading';
import styles from './FJSkeletonScreen.module.less';

interface FJSkeletonScreenItemConfig {
    width: number;
    height: number;
    style?: CSSProperties;
}

type FJSkeletonScreenRowConfig = FJSkeletonScreenItemConfig[];

interface FJSkeletonScreenProps {
    list: FJSkeletonScreenRowConfig[];
    titleClassName?: string;
    ulClassName?: string;
    innerClassName?: string;
    itemClassName?: string;
}

export default function FJSkeletonScreen({
    list,
    titleClassName,
    ulClassName,
    innerClassName,
    itemClassName,
}: FJSkeletonScreenProps): ReactElement | null {
    if (!list?.length) return null;

    const rows = list.map((row, rowIndex) => (
        <div key={rowIndex}>
            <div className={classNames(styles.title, titleClassName)}>
                <FJResourceItemLoading />
            </div>
            <div className={classNames(styles.ul, ulClassName)}>
                <div className={classNames(styles.inner, innerClassName)}>
                    {row.map((item, itemIndex) => (
                        <div
                            key={`${rowIndex}-${itemIndex}`}
                            className={classNames(styles.item, itemClassName)}
                            style={{ width: `${item.width}px`, height: `${item.height}px`, ...item.style }}
                        >
                            <FJResourceItemLoading />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    ));

    return <>{rows}</>;
}
